import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Switch from 'react-switch';
import {
  faCommentsDollar,
  faFileSignature,
  faFileChartPie,
  faUsersCog,
  faUserPlus,
  faUsers,
  faKey,
  faFileUpload,
  faDatabase,
  faTools,
  faLanguage,
  faWarehouseAlt,
  faAlignJustify,
  faHeadset,
  faSitemap,
  faBold,
  faPhoneAlt,
  faBrowser,
  faAddressCard,
  faLocationDot,
  faRectangleHistoryCircleUser,
} from '@fortawesome/pro-light-svg-icons';
import Cluster from './PanelCluster';
// import { Collapse } from '../../../../common/components';
// import Control from './Control';

// actions
import { getAgent, updateAgent } from '../../../../actions/agent';

function ControlContainer({ children }) {
  return (
    <div className="d-flex align-items-center rounded font-large border border-gray my-1">
      {children}
    </div>
  );
}

function Control({
  id,
  icon,
  access,
  disabled,
  title,
  addUser = false,
}) {
  const dispatch = useDispatch();
  const {
    access: { saving },
    adduser: { values = {} },
    details: {
      values: {
        username,
        email,
      },
    },
  } = useSelector(store => store);

  function generateOptions(permId, checked) {
    const options = {};
    options[permId] = checked;
    options.email = email;
    if ((permId === 'can_edit_appointments_profile') && (checked === false)) {
      options.can_edit_appointments_location = false;
    }
    return options;
  }

  function defaultHandleChange(checked) {
    dispatch({ type: 'ACCESS_SAVING' });
    const options = generateOptions(id, checked);
    updateAgent(username, options)
      .then(async () => {
        const { data } = await getAgent(username);
        dispatch({ type: 'LOAD_DETAILS', user: data });
        console.log('data: ', data);
      })
      .finally(() => dispatch({ type: 'ACCESS_DONE_SAVING' }));
  }

  function addUserHandleChange(value) {
    dispatch({ type: 'ADD_USER_PERMISSIONS', id, value });
  }

  return (
    <ControlContainer>
      <div
        className={`d-flex align-items-center justify-content-end bg-lightgray h-100 w-50 ${disabled ? 'text-muted' : ''}`}
      >
        <div htmlFor={id} className="form-label m-0 font-large text-right py-2 ps-1">
          {title}
        </div>
        <FontAwesomeIcon
          icon={icon}
          fixedWidth
          size="2x"
          className={`mx-3 ${disabled ? 'text-muted' : ''}`}
        />
      </div>
      <div className="d-flex align-items-center ps-3">
        <Switch
          id={id}
          checked={addUser ? values[id] : (access || false)}
          onChange={(checked) => (addUser ? addUserHandleChange(checked) : defaultHandleChange(checked))}
          disabled={disabled || saving}
        />
      </div>
    </ControlContainer>
  );
}

function AccessPanel({ user = {}, addUser = false }) {
  const {
    user: {
      username: ownUsername,
      can_edit_users: canEdit,
      is_agency_admin: selfIsAgencyAdmin,
    },
    theme: {
      features: {
        campaigns,
        translations,
        agent_records: agentRecords,
        agencies,
        sites,
        logos,
        rts,
        leadsManagement: leads,
      },
    },
  } = useSelector(store => store);
  const isSelf = user.username === ownUsername;
  const flattenedPermsUser = { ...user, ...user.mmb_permissions };

  return (
    <Row className="fade-in">
      <Col xl="6" className="mb-2">
        <Cluster isOpen name="Account Settings" className="mb-2">
          <Control
            id="password_expired"
            icon={faKey}
            access={flattenedPermsUser.password_expired}
            disabled={!canEdit}
            title="Password Is Expired"
            addUser={addUser}
          />
        </Cluster>
        <Cluster isOpen name="Feature Access" className="mb-2">
          <Control
            id="can_quote"
            icon={faCommentsDollar}
            access={flattenedPermsUser.can_quote}
            disabled={!canEdit}
            title="Agent Portal"
            addUser={addUser}
          />
          <Control
            id="can_enroll"
            icon={faFileSignature}
            access={flattenedPermsUser.can_enroll}
            disabled={!canEdit}
            title="Enrollment Tool"
            addUser={addUser}
          />

          <div className="row fs-3">
            <div className="d-flex col-12 justify-content-center align-items-center">
              Management Portal
            </div>
            {agencies && (
              <div className="d-flex col-12 fs-6 text-muted justify-content-center align-items-center">
                (only one of these options can be active at a time)
              </div>
            )}
          </div>

          <div>
            <Control
              id="is_admin"
              icon={faTools}
              access={flattenedPermsUser.is_admin}
              disabled={flattenedPermsUser.is_agency_admin || !canEdit || isSelf || selfIsAgencyAdmin}
              title="Admin"
              addUser={addUser}

            />
            {agencies && (
              <Control
                id="is_agency_admin"
                icon={faTools}
                access={flattenedPermsUser.is_agency_admin}
                disabled={flattenedPermsUser.is_admin || !canEdit || isSelf || selfIsAgencyAdmin}
                title="Agent Group Admin"
                addUser={addUser}
              />
            )}
          </div>
        </Cluster>
        <Cluster
          isOpen={flattenedPermsUser.can_quote}
          name="Agent Portal"
        >
          {/*
          <Control
            id="can_manage_agents_ap"
            icon={faUsers}
            access={flattenedPermsUser.can_manage_agents_ap}
            disabled={!canEdit}
            title="Agent Management"
            addUser={addUser}
          />
          <Control
            id="can_manage_campaigns_ap"
            icon={faAlignJustify}
            access={flattenedPermsUser.can_manage_campaigns_ap}
            disabled={!canEdit}
            title="Campaigns"
            addUser={addUser}
          />
          */}
          <Control
            id="can_use_telephony"
            icon={faPhoneAlt}
            access={flattenedPermsUser.can_use_telephony}
            disabled={!canEdit}
            title="Can Make and Receive Telephony Calls"
            addUser={addUser}
          />
          <Control
            id="can_view_agent_reports"
            icon={faFileChartPie}
            access={flattenedPermsUser.can_view_agent_reports}
            disabled={!canEdit}
            title="Can View Agent Reports"
            addUser={addUser}
          />
          <Control
            id="can_edit_appointments_profile"
            icon={faAddressCard}
            access={flattenedPermsUser.can_edit_appointments_profile}
            disabled={!canEdit}
            title="Can Edit Appointment Profile Preferences"
            addUser={addUser}
          />
          <Control
            id="can_edit_appointments_location"
            icon={faLocationDot}
            access={flattenedPermsUser.can_edit_appointments_location}
            disabled={!canEdit || !flattenedPermsUser.can_edit_appointments_profile}
            title="Can Edit Locations for Appointments"
            addUser={addUser}
          />
        </Cluster>
      </Col>
      <Col xl="6" className="mb-2">
        <Cluster
          isOpen={flattenedPermsUser.is_admin || flattenedPermsUser.is_agency_admin}
          name="Management Portal"
          className="mb-2"
        >
          <Control
            id="can_view_users"
            icon={faUsers}
            access={flattenedPermsUser.can_view_users}
            disabled={isSelf || !canEdit}
            title="User Admin Access"
            addUser={addUser}
          />
          <Control
            id="can_view_reports"
            icon={faFileChartPie}
            access={flattenedPermsUser.can_view_reports}
            disabled={!canEdit}
            title="Analytics"
            addUser={addUser}
          />
          <Control
            id="can_view_shopper_data"
            icon={faDatabase}
            access={flattenedPermsUser.can_view_shopper_data}
            disabled={!canEdit}
            title="Shopper Data"
            addUser={addUser}
          />
          {translations && flattenedPermsUser.is_admin && (
            <Control
              id="can_edit_translations"
              icon={faLanguage}
              access={flattenedPermsUser.can_edit_translations}
              disabled={!canEdit}
              title="Translations"
              addUser={addUser}
            />
          )}
          {agencies && (
            <Control
              id="can_manage_agency"
              icon={faWarehouseAlt}
              access={flattenedPermsUser.can_manage_agency}
              disabled={!canEdit || !flattenedPermsUser.is_admin}
              title="Agent Groups"
              addUser={addUser}
            />
          )}
          {campaigns && (
            <Control
              id="can_manage_campaigns"
              icon={faAlignJustify}
              access={flattenedPermsUser.can_manage_campaigns}
              disabled={!canEdit || !flattenedPermsUser.is_admin}
              title="Campaigns"
              addUser={addUser}
            />
          )}
          {agentRecords && (
            <Control
              id="can_view_calls"
              icon={faHeadset}
              access={flattenedPermsUser.can_view_calls}
              disabled={!canEdit}
              title="Agent Records"
              addUser={addUser}
            />
          )}
          {leads && (
            <Control
              id="can_manage_leads"
              icon={faRectangleHistoryCircleUser}
              access={flattenedPermsUser.can_manage_leads}
              disabled={!canEdit}
              title="Leads Management"
              addUser={addUser}
            />
          )}
          {sites && (
            <Control
              id="can_manage_formulary"
              icon={faBrowser}
              access={flattenedPermsUser.can_manage_formulary}
              disabled={!canEdit || !flattenedPermsUser.is_admin}
              title="Site Management"
              addUser={addUser}
            />
          )}
          {logos && (
            <Control
              id="can_manage_logos"
              icon={faBold}
              access={flattenedPermsUser.can_manage_logos}
              disabled={!canEdit || !flattenedPermsUser.is_admin}
              title="Carrier Names & Display Names"
              addUser={addUser}
            />
          )}
          {rts && (
            <Control
              id="can_manage_rts"
              icon={faSitemap}
              access={flattenedPermsUser.can_manage_rts}
              disabled={!canEdit || !flattenedPermsUser.is_admin}
              title="RTS Management"
              addUser={addUser}
            />
          )}
        </Cluster>
        <Cluster
          isOpen={(flattenedPermsUser.is_admin || flattenedPermsUser.is_agency_admin) && flattenedPermsUser.can_view_users}
          name="User Admin Permissions"
        >
          <Control
            id="can_edit_users"
            icon={faUsersCog}
            access={flattenedPermsUser.can_edit_users}
            disabled={isSelf || !canEdit}
            title="Edit Users"
            addUser={addUser}
          />
          <Control
            id="can_add_users"
            icon={faUserPlus}
            access={flattenedPermsUser.can_add_users}
            disabled={!canEdit}
            title="Add New Users"
            addUser={addUser}
          />
          <Control
            id="can_batch_upload"
            icon={faFileUpload}
            access={flattenedPermsUser.can_batch_upload}
            disabled={!canEdit}
            title="Batch Upload"
            addUser={addUser}
          />
        </Cluster>
      </Col>
    </Row>
  );
}

export default AccessPanel;
